import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { MainLayout } from 'views/layouts'
import { userSelector } from 'ducks/user'
import { StrokedButton } from 'views/components/UI/Buttons'
import { GetDataHome } from '../../store'
import {
  Container,
  ProcessContainer,
  TextBoldProcess,
  Row,
  ContainerItemProcess,
  ContainerButtonCreateProcess,
} from './styled'
import { H2 } from 'views/components/UI/Text'
import { fetchHomeUserEvaluated } from '../../services/fetch-home-user-evaluated'
import WhiteContainer from 'views/components/common/WhiteContainer'
import DownloadResultCard from 'views/components/Cards/DownloadResults'
import { useTranslation } from 'react-i18next'
import getBetesaReport from 'services/pdfReports/getBetesaReport'
import { useNotification } from 'lib/context/notification.context'
import ModalLoader from 'views/components/UI/ModalLoader'
import getSkillsReport from 'services/pdfReports/getSkillsReport'
import getTest360Report from 'services/pdfReports/getTest360Report'

function DownloadResults() {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { getSuccess } = useNotification()
  const { userId } = useSelector(userSelector)
  const [betesaValidation, setBetesaValidation] = useState<boolean>(false)
  const [competenceValidation, setCompetenceValidation] = useState<boolean>(false)
  const [test360Validation, setTest360Validation] = useState<boolean>(false)
  const [dataDownloadResults, setDataDownloadResults] = useState<GetDataHome[] | null>(null)
  const [loadingReport, setLoadingReport] = useState<boolean>(false)
  const [loading, setLoading] = useState<boolean>(false)

  useEffect(() => {
    setLoading(true)
    const fetchData = async () => {
      try {
        let response = await fetchHomeUserEvaluated()
        response = response.filter((item: any) => {
          // Excluir el objeto completo si contiene Prueba360 con is_evaluator = true
          const hasTest360Evaluator = item.type_category.some(
            (category: any) =>
              category.category_test_name === 'Prueba360' && (category.is_evaluator === true || !category.canShowReport)
          )

          if (hasTest360Evaluator) {
            return false
          }

          // Aplicar el filtro original: incluir solo si participant_report es true Y al menos una categoría tiene access_report true
          return (
            (item.participant_report === true ||
              item.type_category.some((category: any) => category.access_report === true)) &&
            item.type_category.some((category: any) => category.isFinished === true)
          )
        })

        setDataDownloadResults(response)
        setLoading(false)
      } catch (error) {
        console.error('Error fetching data:', error)
        setLoading(false)
      }
    }
    fetchData()
  }, [])

  useEffect(() => {
    const fetchDataValidation = async () => {
      try {
        const competenciasFoundItem = dataDownloadResults?.some((item: any) => {
          return (
            item.participant_report === true ||
            item.type_category.some((category: any) => {
              return category.access_report === true && category.category_test_name === 'Competencias'
            })
          )
        })

        const betesaFoundItem = dataDownloadResults?.some((item: any) => {
          return (
            item.participant_report === true ||
            item.type_category.some((category: any) => {
              return category.access_report === true && category.category_test_name === 'Betesa Premium'
            })
          )
        })

        const test360FoundItem = dataDownloadResults?.some((item: any) => {
          return (
            item.participant_report === true ||
            item.type_category.some((category: any) => {
              return (
                category.access_report === true &&
                category.category_test_name === 'Prueba360' &&
                category.isFinished &&
                category.is_evaluator === false
              )
            })
          )
        })

        setCompetenceValidation(competenciasFoundItem || false)

        setBetesaValidation(betesaFoundItem || false)

        setTest360Validation(test360FoundItem || false)
      } catch (error) {
        console.error('Error fetching data:', error)
      }
    }

    fetchDataValidation()
  }, [dataDownloadResults])

  const downloadBetesaReport = async (userTestId: number) => {
    try {
      setLoadingReport(true)
      const response = await getBetesaReport(userTestId)

      const { url } = response

      window.open(url, '_blank')

      getSuccess(t('global.notifications.reportGenerated'))
      setLoadingReport(false)
    } catch (error) {
      console.error('Error al descargar el reporte de Betesa:', error)
      setLoadingReport(false)
    }
  }

  const downloadSkillsReport = async (userTestId: number) => {
    try {
      setLoadingReport(true)
      const response = await getSkillsReport(userTestId)

      const { url } = response

      window.open(url, '_blank')

      getSuccess(t('global.notifications.reportGenerated'))
      setLoadingReport(false)
    } catch (error) {
      console.error('Error al descargar el reporte de 3D Skills:', error)
      setLoadingReport(false)
    }
  }

  const downloadTest360Report = async (userTestId: number) => {
    try {
      setLoadingReport(true)
      const response = await getTest360Report(userTestId)

      const { url } = response

      window.open(url, '_blank')

      getSuccess(t('global.notifications.reportGenerated'))
      setLoadingReport(false)
    } catch (error) {
      console.error('Error al descargar el reporte de 360°:', error)
      setLoadingReport(false)
    }
  }

  return (
    <MainLayout>
      <Container>
        <H2 margin="30px 0px">{t('evaluatedUser.downloadResults.title')}</H2>
        <ProcessContainer>
          {dataDownloadResults && dataDownloadResults.length > 0 && (
            <ContainerItemProcess>
              {dataDownloadResults.map((item) => (
                <WhiteContainer
                  key={item.process_id}
                  height="100%"
                  padding={window.innerWidth < 992 ? '0px' : '0px'}
                  shadow={window.innerWidth < 992 ? 'none' : '0px 2px 10px rgba(0, 0, 0, 0.1)'}
                >
                  <Row margin="30px 0px" width="100%" justifyContent="flex-start" flexDirection="column" height="100%">
                    <Row justifyContent="center" width="100%" alignItems="center">
                      <TextBoldProcess>
                        {' '}
                        {item.process_name} - {item.company_name}
                      </TextBoldProcess>
                    </Row>
                    <Row
                      margin="10px 0px 0px 0px"
                      width="100%"
                      alignItems="space-between"
                      justifyContent="space-between"
                      flexDirection="column"
                      height="100%"
                    >
                      <div>
                        {item.type_category.map((type, index) => (
                          <Row justifyContent="center" margin="10px 0px" key={index}>
                            {type.category_test_name === 'Betesa Premium' && betesaValidation ? (
                              type.isFinished &&
                              type.domination &&
                              type.domination !== 'No interpretable' && (
                                <DownloadResultCard
                                  title={`Betesa - ${t('global.common.betesaTalentsText')}`}
                                  type="betesa"
                                  onClick={() => downloadBetesaReport(type.user_test_id)}
                                  user_id={userId}
                                  test_id={type.test_id}
                                  user_test_id={type.user_test_id}
                                  style={{ width: '90%' }}
                                />
                              )
                            ) : type.category_test_name === 'Prueba360' &&
                              test360Validation &&
                              type.isFinished &&
                              type.is_evaluator === false ? (
                              <DownloadResultCard
                                title="Evaluación 360°"
                                type="360"
                                onClick={() => downloadTest360Report(type.user_test_id)}
                                user_id={userId}
                                test_id={type.test_id}
                                user_test_id={type.user_test_id}
                                style={{ width: '90%' }}
                              />
                            ) : (
                              type.category_test_name !== 'Betesa Premium' &&
                              type.category_test_name !== 'Prueba360' &&
                              competenceValidation &&
                              type.isFinished && (
                                <DownloadResultCard
                                  title={t('global.common.skillText')}
                                  type="skills"
                                  onClick={() => downloadSkillsReport(type.user_test_id)}
                                  user_id={userId}
                                  test_id={type.test_id}
                                  user_test_id={type.user_test_id}
                                  style={{ width: '90%' }}
                                />
                              )
                            )}
                          </Row>
                        ))}
                      </div>
                      <ContainerButtonCreateProcess>
                        {item.development_plan === true ? (
                          <StrokedButton onClick={() => navigate('/development-plan')}>
                            {t('evaluatedUser.downloadResults.createPlanButtonText')}
                          </StrokedButton>
                        ) : null}
                      </ContainerButtonCreateProcess>
                    </Row>
                  </Row>
                </WhiteContainer>
              ))}
            </ContainerItemProcess>
          )}
        </ProcessContainer>
        <ModalLoader
          isLoading={loadingReport}
          fontWeight={600}
          margin="20px 0"
          text="Estamos generando el archivo..."
        />
        <ModalLoader isLoading={loading} />
      </Container>
    </MainLayout>
  )
}

export default DownloadResults
